export default "__VITE_ASSET__nWvnvJ$b__"